import React from "react"

export const QuestionArrow = ({ color = 'yellow', open }) => {
	const cssRotate90deg = { transform: "rotate(90deg)" }
	return (
		<div style={open === true ? cssRotate90deg : null}>
			<svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M1 1L9 9L1 17" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
			</svg>
		</div>
	);
}

export const Questions = ({ selectedIndex, selectQuestion, lastIndex, compact = false, questionsList }) => {
	return (<>
		{questionsList.map((qa, i) => {
			let css = "p-3 popular_question d-flex flex-row justify-content-between";
			let arrowColor = "#dedede";
			const qIsSelected = i === selectedIndex;
			if (qIsSelected) {
				if (!compact)
					css += " popular_question_selected";
				else
					css += " cursor_pointer";
				arrowColor = "#266663";
			} else {
				css += " cursor_pointer";
			}
			if (i > 0)
				css += " popular_question_border_top";
			if (i > lastIndex)
				return <></>;
			return (
				<div key={'qa' + i}>
					<div className={css} onClick={() => selectQuestion(i)}>
						<div>{qa.q}</div>
						<QuestionArrow
							open={compact && qIsSelected ? true : false}
							color={arrowColor}
						/>
					</div>
					{qIsSelected && compact ?
						<div className="p-3 bg-white">
							{qa.a}
						</div>
						: <></>
					}
				</div>
			);
		})}
	</>)
}

